export default {
  settings: {},
  incidentStatus: 'UP'
}
